import { Component, Input } from '@angular/core';
import { OfferInterface } from '@sport-activities/sdk';

export enum DisplayPlansModeEnum {
  LIGHT = 'LIGHT',
  FULL = 'FULL',
}
@Component({
  selector: 'app-organizer-shared-display-plans',
  templateUrl: './display-plans.component.html',
})
export class OrganizerSharedDisplayPlansComponent {
  @Input() public displayMode: DisplayPlansModeEnum;
  @Input() public plans: OfferInterface[];
  @Input() public plansMaximumCapacity?: number;

  public get isFullMode(): boolean {
    return this.displayMode === DisplayPlansModeEnum.FULL;
  }

  public get isLightMode(): boolean {
    return this.displayMode === DisplayPlansModeEnum.LIGHT;
  }
}
